import * as React from "react";
const SvgFiRrJourney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-journey_svg__a)">
      <path
        fill="#062147"
        d="M1 16.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M3.5 20C1.82 20 .356 21.176.021 22.797a1 1 0 1 0 1.958.406C2.124 22.506 2.763 22 3.5 22s1.376.506 1.521 1.203a1 1 0 1 0 1.958-.406C6.644 21.177 5.18 20 3.5 20M20 14h-9c-1.103 0-2-.897-2-2s.897-2 2-2h1a1 1 0 0 0 0-2h-1c-2.206 0-4 1.794-4 4s1.794 4 4 4h9c1.103 0 2 .897 2 2s-.897 2-2 2H10a1 1 0 0 0 0 2h10c2.206 0 4-1.794 4-4s-1.794-4-4-4m-4.497-6.61-.862 2.764a.917.917 0 0 0 1.385 1.037l2.482-1.66 2.524 1.643a.917.917 0 0 0 1.371-1.056l-.897-2.732 2.169-1.767a.916.916 0 0 0-.59-1.618h-2.751L19.36 1.27a.916.916 0 0 0-1.718 0l-.974 2.732h-2.751a.916.916 0 0 0-.593 1.616z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-journey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrJourney;
